import React, { useState, useEffect, Fragment } from 'react';
import Footer from './footer';
import Menu from './menu'; // Asumo que este Menu es para otro layout, ya que usas Menu2
import StepProgressBar from 'react-step-progress';
import Paso1 from '../Formulario/paso1';
import Paso2 from '../Formulario/paso2';
import Paso4 from '../Formulario/paso4';
import Paso3 from '../Formulario/paso3';
import ResultadoSolicitud from '../Formulario/resultadoSolicitud';
import MensajeAdvertencia from '../../Services/MensajeAdvertencia';
import Bienvenida from '../Formulario/bienvenida';
import Menu2 from './menu2';
import { ReembolsoSevices } from '../../Services';

const SITE_KEY = "6LcnogsaAAAAAIRnBz6EHYHRy4cJDHi7C4f0h-qq"; // Asegúrate que estas son las correctas para tu entorno
// const SECRET_KEY = "6LcnogsaAAAAAONK78K9cH-8NEkw18U_7wNTvPCV"; // SECRET_KEY no se usa en el frontend

const LayoutFormulario = (props) => {
    const [ModoPrueba] = useState(false); // FLAG PARA PASAR CONSUMOS DE WS
    
    // Definición de las funciones validadoras ANTES de usarlas en el array Pasos
    // Asegúrate que MensajeAdvertencia está disponible en este scope, 
    // ya sea globalmente o importada y pasada si es necesario.

    function ValidarPaso1() {
        if (ModoPrueba) { // Si está en ModoPrueba, siempre es válido
            return true;
        }

        const paso1ValidadoStorage = window.localStorage.getItem("Paso1");
        // En Paso1.js, "TieneDocumentos" se guarda como "true" o "false" (strings)
        const tieneDocumentosStorage = window.localStorage.getItem("TieneDocumentos");

        if (tieneDocumentosStorage === "false") {
            // Si el usuario explícitamente indicó que NO tiene documentos,
            // el paso 1 se considera completo/válido en términos de no requerir más datos.
            return true;
        } else if (tieneDocumentosStorage === "true") {
            // Si el usuario indicó que SÍ tiene documentos,
            // verificamos si la lógica interna de Paso1.js marcó el paso como válido.
            // "Paso1" en localStorage guarda btoa("true") o btoa("false").
            if (paso1ValidadoStorage === btoa(true.toString())) {
                return true; // El Paso1.js determinó que todos los campos obligatorios están llenos y correctos.
            } else if (paso1ValidadoStorage === btoa(false.toString())) {
                MensajeAdvertencia("Advertencia", "Debe llenar todos los campos obligatorios y corregir los errores en el Paso 1 para continuar.", "warning", "Reintentar");
                return false;
            } else {
                // Caso donde "TieneDocumentos" es "true", pero "Paso1" no está (o no es ni true ni false).
                // Esto podría ocurrir si CamposObligatoriosCorrectos en Paso1.js no se ejecutó o falló.
                // Es más seguro tratarlo como inválido.
                MensajeAdvertencia("Advertencia", "Información incompleta en el Paso 1. Por favor, verifique los campos.", "warning", "Reintentar");
                return false;
            }
        } else {
            // Caso donde "TieneDocumentos" no existe en localStorage o tiene un valor inesperado.
            // Esto es probable al inicio, antes de cualquier interacción con Paso1.js.
            // En este escenario, el wizard no debería avanzar si este es el validador activo,
            // a menos que la lógica de "Bienvenida" (step0) maneje la transición inicial.
            // Si se llega aquí, significa que el usuario está intentando pasar del paso "Validación"
            // sin haber interactuado con la primera pregunta.
            MensajeAdvertencia("Advertencia", "Por favor, complete la validación inicial para continuar.", "warning", "Reintentar");
            return false;
        }
    }

    function ValidarPaso2() {
        if (ModoPrueba) {
            return true;
        }
        if (navigator.onLine) {
            // var Paso2Validado = window.localStorage.getItem("Paso2");
            // Asumimos que Paso2 también guarda btoa("true") o btoa("false")
            // if (Paso2Validado === btoa(false.toString())) {
            //     MensajeAdvertencia("Advertencia", "Debe llenar los campos obligatorios en el Paso 2 para continuar.", "warning", "Reintentar");
            //     return false;
            // } else if (Paso2Validado === btoa(true.toString())) {
            //     return true;
            // } else {
            //     // Si no está explícitamente validado o invalidado, pero se requiere, es mejor asumir que no es válido.
            //     MensajeAdvertencia("Advertencia", "Información incompleta en el Paso 2. Por favor, verifique los campos.", "warning", "Reintentar");
            //     return false;
            // }
            return true;
        } else {
            MensajeAdvertencia("Sin internet", "Actualmente no posee conexión a internet.", "warning", "Ok");
            return false;
        }
    }

    function ValidarPaso3() {
        if (ModoPrueba) {
            return true;
        }
        if (navigator.onLine) {
            var Paso3Validado = window.localStorage.getItem("Paso3");
            // Asumimos que Paso3 también guarda btoa("true") o btoa("false")
            if (Paso3Validado === btoa(false.toString())) {
                MensajeAdvertencia("Advertencia", "Debe llenar los campos obligatorios en el Paso 3 para continuar.", "warning", "Reintentar");
                return false;
            } else if (Paso3Validado === btoa(true.toString())) {
                return true;
            } else {
                MensajeAdvertencia("Advertencia", "Información incompleta en el Paso 3. Por favor, verifique los campos.", "warning", "Reintentar");
                return false;
            }
        } else {
            MensajeAdvertencia("Sin internet", "Actualmente no posee conexión a internet.", "warning", "Ok");
            return false;
        }
    }
    
    const step0Content = <Bienvenida />;
    const step1Content = <Paso1 />; // El componente Paso1.js que hemos estado modificando
    const step2Content = <Paso2 />;
    const step3Content = <Paso3 />;
    const step4Content = <Paso4 />;
    const step5Content = <ResultadoSolicitud />;

    const [Pasos] = useState([
        {
            name: 'Bienvenida', // Nombre único para el paso
            label: 'Bienvenida',
            content: step0Content,
            validator: () => true // El primer paso usualmente no tiene validador o siempre es true
        },
        {
            name: 'Validación', // Nombre único
            label: 'Validación', // Lo que se muestra en la barra
            content: step1Content,
            validator: ValidarPaso1 // Referencia a la función ajustada
        },
        {
            name: 'Boleto', // Nombre único
            label: 'Boleto',
            content: step2Content,
            validator: ValidarPaso2
        },
        {
            name: 'Motivo', // Nombre único
            label: 'Motivo',
            content: step3Content,
            validator: ValidarPaso3
        },
        {
            name: 'Documentos', // Nombre único
            label: 'Documentos',
            content: step4Content,
            validator: () => true // Asumiendo que el paso 4 no necesita validación para avanzar o se maneja internamente
        },
        {
            name: 'Resultado', // Nombre único
            label: 'Resultado',
            content: step5Content,
            validator: () => true // Último paso usualmente no tiene validador de "siguiente"
        }
    ]);

    useEffect(() => {
        // La validación de reCAPTCHA se puede mantener si es necesaria para la lógica general del formulario.
        // (async function anyNameFunction() {
        //     ValidarRechapcha();
        // })();
        // Si ValidarRechapcha es costoso o no necesario en cada render, considera sus dependencias.
    }, []);

    // async function ValidarRechapcha() { // Tu lógica de reCAPTCHA ... }
    // async function Chequear(params) { // Tu lógica de reCAPTCHA ... }
    // Mantenidas como estaban en tu código original si son necesarias


    function onFormSubmit() {
        // Esta función se llama cuando se completa el último paso del StepProgressBar.
        // Aquí puedes manejar el envío final de todos los datos recopilados.
        console.log("Formulario completado y enviado (simulado)");
        // Por ejemplo, recolectar toda la información de localStorage y enviarla a un backend.
        // Luego, redirigir o mostrar un mensaje final.
        // window.location.href = "https://avior.com.ve"; // Descomentar si es el comportamiento deseado
        MensajeAdvertencia("Éxito", "Su solicitud de reembolso ha sido procesada (simulación).", "success", "Ok").then(() => {
            // Opcionalmente, limpiar localStorage después de un envío exitoso
            // window.localStorage.clear(); 
            // window.location.href = "https://avior.com.ve"; 
        });
    }

    return (
        <>
            <Menu2 />
            <div className="theme-page-section _pt-90" style={{ minHeight: "100vh" }}>
                <div className="container ">
                    <StepProgressBar
                        primaryBtnClass={"btn btn-primary _bg-p"}
                        secondaryBtnClass={"btn btn-primary-inverse _c-dark btn-white hover-Oscuro"}
                        previousBtnName={"Anterior"}
                        nextBtnName={"Siguiente"}
                        startingStep={0}
                        progressClass={'_c-dark'} // Clases para la barra de progreso
                        stepClass={'_c-dark'}     // Clases para los indicadores de paso
                        onSubmit={onFormSubmit}
                        steps={Pasos}
                    />
                </div>
            </div>
            <Footer />
        </>
    );
}
export default LayoutFormulario;